<template>
	<div>
		<el-row style="margin-top: 10px;">
			<el-col class="border" :span="24">
				<div class="d3title" style="padding-bottom: 10px;">发型师成本统计
					<!-- <el-button class="right" type="primary" size="small" @click="plsc">录入</el-button>
					<input type="file" name="file" style="opacity: 0;position: absolute;display: none;" id="sj"
						@change="xuanzhe($event)" /> -->
					<el-button class="right" type="primary" size="small" @click="exportss">导出</el-button>
					<!-- <el-date-picker
				       v-model="month"
				       type="month"
				       placeholder="选择月">
				     </el-date-picker> -->
				</div>
				<div class='left'>
					<!-- <div style="margin-right: 10px;">
						<el-select v-model="storeId" @change="getList()" clearable 
							style="width: 150px; margin-right: 30px;" size="small">
							<el-option-group label="营业门店" class="store">
								<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-option-group>
							<el-option-group label="结业门店">
								<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-option-group>
						</el-select>
					</div> -->
					<!-- <el-button class="right" type="primary" size="small" @click="getList()">本月</el-button> -->
					<!-- <el-button class="right" type="primary" size="small" @click="getList(-1)">上月</el-button> -->
					<el-button class="right" type="primary" size="small" @click="pop5 = true">底薪扣除</el-button>
					<el-button class="right" type="primary" size="small" @click="pop1 = true">添加警告信</el-button>
					<el-button class="right" type="primary" size="small" @click="pop2 = true">添加杂费</el-button>
					<el-button class="right" type="primary" size="small" @click="pop3 = true">添加额外提成</el-button>
					<el-button class="right" type="primary" size="small" @click="pop4 = true">添加试工业绩</el-button>
					<el-date-picker class="right" v-model="month" type="month" placeholder="选择月">
					</el-date-picker>
					<el-button class="right" type="primary" size="small" @click="getList()">筛选</el-button>
					<!-- <div style="margin-right: 10px;">
						<el-date-picker
						@change="getList(0)"
						      v-model="time"
						      type="daterange"
							  value-format="yyyy-MM-dd"
						      range-separator="至"
						      start-placeholder="开始日期"
						      end-placeholder="结束日期"
							  clearable>
						    </el-date-picker>
					</div> -->
				</div>
			</el-col>
		</el-row>
		<el-dialog title="底薪扣除" :visible.sync="pop5" width="30%">
			<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
				<el-form-item label="日期">
					<el-date-picker v-model="addDataList.date" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="发型师">
					<!-- <el-input v-model="addDataList.workerName" size="small" style="width: 300px;"></el-input> -->
					<input type="text" v-model="workerList1.name" @keydown.enter="getWorkerList1(workerList1.name)"
						placeholder="输入发型师姓名" style="font-size:15px;padding: 5px;margin:15px;">
					<el-radio-group v-if="workerList1.id!=''" v-model="radio">
						<el-radio v-for="j in workerList1" @click.native.prevent="check(j.id,j.name)">
							{{j.id}}{{j.name}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="扣除金额">
					<el-input v-model="addDataList.money" size="small" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="扣除事由">
					<el-input v-model="addDataList.msg" size="small" style="width: 300px;"></el-input>
				</el-form-item>
			</el-form>
			<div class="add_botom">
				<div class="add_botom_nei">
					<el-button size="small" @click="pop5=false">取消</el-button>
					<el-button size="small" type="primary" @click="add(4)">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="警告信" :visible.sync="pop1" width="30%">
			<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
				<el-form-item label="日期">
					<el-date-picker v-model="addDataList.date" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="发型师">
					<!-- <el-input v-model="addDataList.workerName" size="small" style="width: 300px;"></el-input> -->
					<input type="text" v-model="workerList1.name" @keydown.enter="getWorkerList1(workerList1.name)"
						placeholder="输入发型师姓名" style="font-size:15px;padding: 5px;margin:15px;">
					<el-radio-group v-if="workerList1.id!=''" v-model="radio">
						<el-radio v-for="j in workerList1" @click.native.prevent="check(j.id,j.name)">
							{{j.id}}{{j.name}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="金额">
					<el-input v-model="addDataList.money" size="small" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="警告事由">
					<el-input v-model="addDataList.msg" size="small" style="width: 300px;"></el-input>
				</el-form-item>
			</el-form>
			<div class="add_botom">
				<div class="add_botom_nei">
					<el-button size="small" @click="pop1 = false">取消</el-button>
					<el-button size="small" type="primary" @click="add(1)">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="杂费" :visible.sync="pop2" width="30%">
			<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
				<el-form-item label="日期">
					<el-date-picker v-model="addDataList.date" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="发型师">
					<!-- <el-input v-model="addDataList.workerName" size="small" style="width: 300px;"></el-input> -->
					<input type="text" v-model="workerList1.name" @keydown.enter="getWorkerList1(workerList1.name)"
						placeholder="输入发型师姓名" style="font-size:15px;padding: 5px;margin:15px;">
					<el-radio-group v-if="workerList1.id!=''" v-model="radio">
						<el-radio v-for="j in workerList1" @click.native.prevent="check(j.id,j.name)">
							{{j.id}}{{j.name}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="金额">
					<el-input v-model="addDataList.money" size="small" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="杂费事项">
					<el-input v-model="addDataList.msg" size="small" style="width: 300px;"></el-input>
				</el-form-item>
			</el-form>
			<div class="add_botom">
				<div class="add_botom_nei">
					<el-button size="small" @click="pop2=false">取消</el-button>
					<el-button size="small" type="primary" @click="add(2)">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="额外提成" :visible.sync="pop3" width="30%">
			<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
				<el-form-item label="日期">
					<el-date-picker v-model="addDataList.date" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="发型师">
					<!-- <el-input v-model="addDataList.workerName" size="small" style="width: 300px;"></el-input> -->
					<input type="text" v-model="workerList1.name" @keydown.enter="getWorkerList1(workerList1.name)"
						placeholder="输入发型师姓名" style="font-size:15px;padding: 5px;margin:15px;">
					<el-radio-group v-if="workerList1.id!=''" v-model="radio">
						<el-radio v-for="j in workerList1" @click.native.prevent="check(j.id,j.name)">
							{{j.id}}{{j.name}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="金额">
					<el-input v-model="addDataList.money" size="small" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="提成事项">
					<el-input v-model="addDataList.msg" size="small" style="width: 300px;"></el-input>
				</el-form-item>
			</el-form>
			<div class="add_botom">
				<div class="add_botom_nei">
					<el-button size="small" @click="pop3=false">取消</el-button>
					<el-button size="small" type="primary" @click="add(3)">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="添加试工业绩" :visible.sync="pop4" width="30%">
			<el-form ref="form" :model="shigongyeji" label-width="150px" label-position="left">
				<el-form-item label="日期">
					<el-date-picker v-model="shigongyeji.date" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="发型师">
					<!-- <el-input v-model="addDataList.workerName" size="small" style="width: 300px;"></el-input> -->
					<input type="text" v-model="workerList1.name" @keydown.enter="getWorkerList1(workerList1.name)"
						placeholder="输入发型师姓名" style="font-size:15px;padding: 5px;margin:15px;">
					<el-radio-group v-if="workerList1.id!=''" v-model="radio">
						<el-radio v-for="j in workerList1" @click.native.prevent="check(j.id,j.name)">
							{{j.id}}{{j.name}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="添加业绩">
					<el-input v-model="shigongyeji.yeji" size="small" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="添加会员-新">
					<el-input v-model="shigongyeji.xinhuiyuan" size="small" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="添加会员-老">
					<el-input v-model="shigongyeji.laohuiyuan" size="small" style="width: 300px;"></el-input>
				</el-form-item>
			</el-form>
			<div class="add_botom">
				<div class="add_botom_nei">
					<el-button size="small" @click="pop4=false">取消</el-button>
					<el-button size="small" type="primary" @click="addYeji()">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<div style="margin-top: 10px;" v-loading="loading">
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="list"
				tooltip-effect="dark" style="width: 100%" height='80vh'>
				<el-table-column label="日期">
					<template slot-scope="scope">
						{{scope.row.month}}
					</template>
				</el-table-column>
				<el-table-column label="发型师">
					<template slot-scope="scope">
						{{ scope.row.name }}
					</template>
				</el-table-column>
				<el-table-column label="套餐提成" width="120px" prop="taocanticheng" sortable>
					<template slot-scope="scope">
						{{ scope.row.taocanticheng?scope.row.taocanticheng:'0'}}
					</template>
				</el-table-column>
				<el-table-column label="实际完成业绩" width="130px" prop="yeji" sortable>
					<template slot-scope="scope">
						{{ scope.row.yeji }}
					</template>
				</el-table-column>
				<el-table-column label="业绩比例" width="120px">
					<template slot-scope="scope">
						{{scope.row.yejibili}}%
					</template>
				</el-table-column>
				<el-table-column label="业绩提成" width="120px" prop="yejitc" sortable>
					<template slot-scope="scope">
						{{ scope.row.yejitc}}
					</template>
				</el-table-column>
				<el-table-column label="差评扣罚" width="120px" prop="chaping" sortable>
					<template slot-scope="scope">
						{{ scope.row.chaping}}
					</template>
				</el-table-column>
				<el-table-column label="迟到/早退扣罚" width="140px" prop="chidaozaotui" sortable>
					<template slot-scope="scope">
						{{0}}
					</template>
				</el-table-column>
				<el-table-column label="疫情天数" width="140px" prop="yiqingdays" sortable>
					<template slot-scope="scope">
						{{scope.row.yiqingdays}}
					</template>
				</el-table-column>
				<el-table-column label="病假扣罚" width="120px">
					<template slot-scope="scope">
						{{0}}
					</template>
				</el-table-column>
				<el-table-column label="事假扣罚" width="120px" prop="qingjia" sortable>
					<template slot-scope="scope">
						{{scope.row.qingjia}}
					</template>
				</el-table-column>
				<el-table-column label="警告信" width="120px" prop="jinggaoxin" sortable>
					<template slot-scope="scope">
						{{scope.row.jinggaoxin}}
					</template>
				</el-table-column>
				<el-table-column label="杂费" width="120px" prop="zafei" sortable>
					<template slot-scope="scope">
						{{scope.row.zafei}}
					</template>
				</el-table-column>
				<el-table-column label="销售奖励" width="120px" prop="xaoshoujiangli" sortable>
					<template slot-scope="scope">
						{{scope.row.xiaoshoujiangli}}
					</template>
				</el-table-column>
				<el-table-column label="额外提成" width="120px" prop="xaoshoujiangli" sortable>
					<template slot-scope="scope">
						{{scope.row.qitaticheng}}
					</template>
				</el-table-column>
				<el-table-column label="基本工资" width="120px" prop="baseSalary" sortable>
					<template slot-scope="scope">
						{{scope.row.baseSalary}}
					</template>
				</el-table-column>
				<el-table-column label="本月提成" width="120px" prop="zongticheng" sortable>
					<template slot-scope="scope">
						{{ scope.row.zongticheng}}
					</template>
				</el-table-column>
				<el-table-column label="出勤天数" width="120px" prop="days" sortable>
					<template slot-scope="scope">
						{{ scope.row.days?scope.row.days:'0'}}
					</template>
				</el-table-column>
				<el-table-column label="入/离职日期" width="120px" prop="joinTime" sortable>
					<template slot-scope="scope">
						{{scope.row.joinTime==scope.row.month?'入'+scope.row.joinTime:(scope.row.leaveTime==scope.row.month?'离'+scope.row.leaveTime:'')}}
					</template>
				</el-table-column>
				<el-table-column label="出勤店铺" width="200px">
					<template slot-scope="scope">
						{{scope.row.storeName}}
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from "../../utils/index.js";
	import {
		formatMoney
	} from "../../utils/index.js"
	import {
		export2Excel
	} from '../../common/js/util'
	export default {
		data() {
			return {
				url: url(),
				list: [],
				time: [],
				month: `${new Date().getFullYear()}-${new Date().getMonth() < 10 ? `0${new Date().getMonth()+1 }` : new Date().getMonth()+1 }`,
				storeId: '',
				storeEnd: [],
				storeList: [],
				allStoreList: [],
				storeName: '',
				loading: false,
				date0: '',
				date1: '',
				pop1: false,
				pop2: false,
				pop3: false,
				pop4: false,
				pop5: false,
				addDataList: {
					workerName: '',
					workerId: '',
					msg: "",
					money: 0,
					date: ''
				},
				shigongyeji: {
					workerName: '',
					workerId: '',
					yeji: 0,
					date: '',
					xinhuiyuan: 0,
					laohuiyuan: 0
				},
				workerList1: {
					id: '',
					name: "",
					storeName: "",
					motor: '',
					status: "",
				},
				columns: [{
					title: '日期',
					key: 'month'
				}, {
					title: '发型师',
					key: 'name'
				}, {
					title: '套餐提成',
					key: 'taocanticheng'
				}, {
					title: '实际完成业绩',
					key: 'yeji'
				}, {
					title: '业绩比例',
					key: 'yejibili'
				}, {
					title: '业绩提成',
					key: 'yejitc'
				}, {
					title: '差评扣罚',
					key: 'qingjia'
				}, {
					title: '事假扣罚',
					key: 'chaping'
				}, {
					title: '警告信',
					key: 'jinggaoxin'
				}, {
					title: '杂费',
					key: 'zafei',
				},{
					title: '销售奖励',
					key: 'xiaoshoujiangli',
				},{
					title: '额外提成',
					key: 'qitaticheng',
				},{
					title: '基本工资',
					key: 'baseSalary',
				},{
					title: '本月提成',
					key: 'zongticheng',
				},{
					title: '出勤天数',
					key: 'days',
				}, {
					title: '出勤店铺',
					key: 'storeName',
				} ]
			}
		},
		mounted() {
			this.date0 =
				`${new Date().getFullYear()}-${new Date().getMonth()+1 < 10 ? `0${new Date().getMonth()+1 }` : new Date().getMonth()+1 }`
			// this.getStores()
			this.getList(0)
		},
		methods: {
			exportss() {
				this.getList();
				var a = this.list
				export2Excel(this.columns, a)
			},
			//获取发型师成本统计列表
			getList(t) {
				var a = {}
				if (this.month ==
					`${new Date().getFullYear()}-${new Date().getMonth() < 10 ? `0${new Date().getMonth()+1 }` : new Date().getMonth()+1 }`
				) {
					a.month = this.month
				} else {
					a.month =
						`${this.month.getFullYear()}-${this.month.getMonth()+1 < 10 ? `0${this.month.getMonth()+1 }` : this.month.getMonth()+1 }`
				}
				this.$http.get("dWorkerCostDetail/workerCostDetailList?month=" + a.month).then(res => {
					this.list = res.body.data;
				})
			},
			// 添加杂费/警告信/提成
			add(t) {
				if (this.addDataList.workerId == '' || this.addDataList.workerId == null) {
					this.$message.success("未选中发型师")
				} else if (this.addDataList.money == null) {
					this.$message.success("未填写金额")
				} else if (this.addDataList.date == '' || this.addDataList.date == null) {
					this.$message.success("未选中时间")
				} else {
					var arr = {
						workerName: this.addDataList.workerName,
						workerId: this.addDataList.workerId,
						money: this.addDataList.money,
						msg: this.addDataList.msg,
						date: `${this.addDataList.date.getFullYear()}-${this.addDataList.date.getMonth()+1 < 10 ? `0${this.addDataList.date.getMonth()+1 }` : this.addDataList.date.getMonth()+1 }-${this.addDataList.date.getDate() < 10 ? `0${this.addDataList.date.getDate() }` : this.addDataList.date.getDate() }`
					}
					console.log(arr)
					if (t == 1) {
						arr.type = 1
					} else if (t == 2) {
						arr.type = 2
					} else if (t == 3) {
						arr.type = 3
					} else if (t == 4) {
						arr.type = 4
					} else {
						arr.type = 0
					}
					this.$http.post("dWorkerCostCount/addWorkerCostCount", JSON.stringify(arr)).then(res => {
						console.log(res)
						if (res.body.code == 200) {
							this.$message.success("添加成功")
							this.pop1 = false
							this.pop2 = false
							this.pop3 = false
							this.pop5 = false
						}
					})
					this.addDataList = [];
					this.getList()
				}
			},
			// 为发型师添加业绩
			addYeji() {
				if (this.addDataList.workerId == '' || this.addDataList.workerId == null) {
					this.$message.success("未选中发型师")
				} else if (this.shigongyeji.date == '' || this.shigongyeji.date == null) {
					this.$message.success("未选中时间")
				} else {
					var arr = {
						workerName: this.addDataList.workerName,
						workerId: this.addDataList.workerId,
						yeji: this.shigongyeji.yeji == null ? "0" : this.shigongyeji.yeji,
						xinhuiyuan: this.shigongyeji.xinhuiyuan == null ? "0" : this.shigongyeji.xinhuiyuan,
						laohuiyuan: this.shigongyeji.laohuiyuan == null ? "0" : this.shigongyeji.laohuiyuan,
						addTime: `${this.shigongyeji.date.getFullYear()}-${this.shigongyeji.date.getMonth()+1 < 10 ? `0${this.shigongyeji.date.getMonth()+1 }` : this.shigongyeji.date.getMonth()+1 }-${this.shigongyeji.date.getDate() < 10 ? `0${this.shigongyeji.date.getDate() }` : this.shigongyeji.date.getDate() }`
					}
					this.$http.post("dOrderCommission/addYeji", JSON.stringify(arr)).then(res => {
						if (res.ok == true) {
							this.$message.success("添加成功")
							this.pop4 = false
						}
					})
					this.pop4 = false
					this.shigongyeji = [];
					this.addDataList = [];
					this.getList()
				}
			},
			// 搜索发型师
			getWorkerList1(name) {
				this.$http.get("dWorker/queryAll" + "?name=" + name).then(res => {
					this.workerList1 = res.body.data;
				})
			},
			// 选择发型师
			check(id, name) {
				this.addDataList.workerName = name
				this.addDataList.workerId = id
				this.workerList1.name = name
			},
			//获取门店列表
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						this.allStoreList.push(ele)
						if (ele.businessType === 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.red {
		color: red;
	}

	.blue {
		width: 6px;
		height: 25px;
		background-color: #00a0e9;
	}

	.right {
		float: right;
		margin-right: 10px;
	}

	.left {
		padding: 10px;
		margin-right: 10px;
		display: flex;
		// background-color: #ecebeb;
	}

	.border {
		box-shadow: rgba(13, 13, 13, 0.53) 2px 1px 5px;
		padding: 10px 10px 0px 15px;
	}

	.radius {
		/*border: 2px solid;*/
		border-radius: 8px;
	}

	.d1 {
		color: #ffffff;
		background: linear-gradient(to right, #69a0ff, #3ee2b0);
		font-size: 18px;
		padding: 10px 10px 10px 20px;

		.d1title {
			color: #ffffff;
		}

		.d1content {
			color: #ffffff;
			font-size: 38px;
			font-weight: 800;
			font-family: SourceHanSansCN-Bold;
		}
	}

	.dfont {
		color: #bfbfbf;
		margin-left: 10px;
		margin-top: 5px;
		font-size: 20px;
	}

	.d2 {
		margin-top: 5px;
		line-height: 40px;
		border-bottom: #ecebeb 1px solid;

		.f {
			width: 7px;
			height: 40px;
			background-color: #69a0ff;
		}

		.f01 {
			width: 7px;
			height: 40px;
			background-color: #6fe9c3;
		}

		.f02 {
			width: 7px;
			height: 40px;
			background-color: #7285a5;
		}
	}

	.d3title {
		font-weight: 800;
		font-size: 18px;
	}

	.d4title {
		font-weight: 800;
		font-size: 16px;
		flex: 1;
		background-color: #efefef;
		text-align: center;
	}

	.d4content {
		flex: 1;
		text-align: center;
	}

	.dtitle {
		margin-left: 5px;
		margin-top: 3px;
		line-height: 40px;
		font-size: 22px;
		flex: 10%;
		color: #a7a7a7;
		color: ;
	}

	.dcontent {
		margin-top: 3px;
		line-height: 40px;
		float: right;
		font-size: 24px;
	}
</style>